import { Fragment,   ReactNode,useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }: { children: ReactNode }): ReactNode => {
  const location = useLocation();

  useEffect((): void => {
    window.scrollTo(0, 0);
  }, [location]);

  return <Fragment>{children}</Fragment>;
};

export default ScrollToTop;
